export default __webpack_public_path__ + "static/media/activity-9.97c6ccc5.png";